import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { CreditCard, Zap } from 'lucide-react'
import Modal from './Modal'
import { useRecruiterSubscriptionModal } from '@/stores/recruiterSubscriptionStore'

export default function RecruiterSubscriptionModal() {
  const { t } = useTranslation('auth')
  const { isOpen, hideModal } = useRecruiterSubscriptionModal()
  const navigate = useNavigate()

  const handleViewPlans = () => {
    hideModal()
    navigate('/recruiter/packs')
  }

  return (
    <Modal isOpen={isOpen} onClose={hideModal} size="md">
      <div className="text-center">
        {/* Icon */}
        <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
          <CreditCard className="w-8 h-8 text-white" />
        </div>

        {/* Title */}
        <h2 className="text-2xl font-bold text-gray-900 mb-3">
          {t('recruiterSubscription.title')}
        </h2>

        {/* Message */}
        <p className="text-gray-600 mb-6">
          {t('recruiterSubscription.message')}
        </p>

        {/* Feature list */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6 text-left">
          <h3 className="text-sm font-semibold text-gray-900 mb-3">
            {t('recruiterSubscription.whatYouGet')}
          </h3>
          <div className="space-y-2">
            {(t('recruiterSubscription.features', { returnObjects: true }) as string[]).map(
              (feature, i) => (
                <div key={i} className="flex items-center gap-2">
                  <Zap className="w-4 h-4 text-blue-600 flex-shrink-0" />
                  <p className="text-sm text-gray-700">{feature}</p>
                </div>
              )
            )}
          </div>
        </div>

        {/* CTA */}
        <button
          onClick={handleViewPlans}
          className="w-full px-4 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-colors mb-3"
        >
          {t('recruiterSubscription.viewPlansButton')}
        </button>

        <button
          onClick={hideModal}
          className="w-full px-4 py-3 bg-white hover:bg-gray-50 text-gray-700 border border-gray-300 rounded-lg font-medium transition-colors"
        >
          {t('recruiterSubscription.cancelButton')}
        </button>
      </div>
    </Modal>
  )
}
